var cov_2k8pykc5aw = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/FileInput.tsx",
      hash = "8cf2e1786e3f7041ac0ff41f7ed99ea0f05b688e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/FileInput.tsx",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 19
        },
        end: {
          line: 4,
          column: 38
        }
      },
      "1": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 16
        }
      },
      "2": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 23
        }
      },
      "3": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 50
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 19
        }
      },
      "5": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 27
        }
      },
      "6": {
        start: {
          line: 23,
          column: 21
        },
        end: {
          line: 23,
          column: 27
        }
      },
      "7": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 22
        }
      },
      "8": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 25
        }
      },
      "9": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 22
        }
      },
      "10": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 31,
          column: 12
        }
      },
      "11": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 25
        }
      },
      "12": {
        start: {
          line: 35,
          column: 60
        },
        end: {
          line: 35,
          column: 70
        }
      },
      "13": {
        start: {
          line: 36,
          column: 24
        },
        end: {
          line: 36,
          column: 43
        }
      },
      "14": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 37
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 36
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 10
          },
          end: {
            line: 32,
            column: 3
          }
        },
        line: 22
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 29,
            column: 15
          },
          end: {
            line: 29,
            column: 16
          }
        },
        loc: {
          start: {
            line: 29,
            column: 21
          },
          end: {
            line: 31,
            column: 5
          }
        },
        line: 29
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        loc: {
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 27
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 27
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/FileInput.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
var inputStyle = (cov_2k8pykc5aw.s[0]++, {
  display: 'none'
});

var FileInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FileInput, _PureComponent);

  var _super = _createSuper2(FileInput);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    cov_2k8pykc5aw.f[0]++;
    cov_2k8pykc5aw.s[1]++;
    _this = _super.call(this, props);
    _this.locked = void 0;
    _this.input = void 0;
    cov_2k8pykc5aw.s[2]++;
    _this.locked = false;
    cov_2k8pykc5aw.s[3]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FileInput, [{
    key: "bindElement",
    value: function bindElement(el) {
      cov_2k8pykc5aw.f[1]++;
      cov_2k8pykc5aw.s[4]++;
      this.input = el;
    }
  }, {
    key: "click",
    value: function click() {
      var _this2 = this;

      cov_2k8pykc5aw.f[2]++;
      cov_2k8pykc5aw.s[5]++;

      if (this.locked) {
        cov_2k8pykc5aw.b[0][0]++;
        cov_2k8pykc5aw.s[6]++;
        return;
      } else {
        cov_2k8pykc5aw.b[0][1]++;
      }

      cov_2k8pykc5aw.s[7]++;
      this.locked = true;
      cov_2k8pykc5aw.s[8]++;
      this.input.value = '';
      cov_2k8pykc5aw.s[9]++;
      this.input.click();
      cov_2k8pykc5aw.s[10]++;
      setTimeout(function () {
        cov_2k8pykc5aw.f[3]++;
        cov_2k8pykc5aw.s[11]++;
        _this2.locked = false;
      }, 1000);
    }
  }, {
    key: "render",
    value: function render() {
      cov_2k8pykc5aw.f[4]++;

      var _ref = (cov_2k8pykc5aw.s[12]++, this.props),
          accept = _ref.accept,
          onChange = _ref.onChange,
          multiple = _ref.multiple,
          webkitdirectory = _ref.webkitdirectory;

      var OriginProps = (cov_2k8pykc5aw.s[13]++, {
        webkitdirectory: webkitdirectory
      });
      cov_2k8pykc5aw.s[14]++;
      return (
        /*#__PURE__*/
        React.createElement("input", Object.assign({
          ref: this.bindElement,
          accept: accept,
          multiple: multiple,
          onChange: onChange,
          style: inputStyle,
          type: "file"
        }, OriginProps, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 38,
            columnNumber: 7
          }
        }))
      );
    }
  }]);

  return FileInput;
}(PureComponent);

export default FileInput;